import script from "./BasketLineItemModuleConfiguration.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasketLineItemModuleConfiguration.vue?vue&type=script&lang=ts&setup=true"

import "./BasketLineItemModuleConfiguration.vue?vue&type=style&index=0&id=7f626a04&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f626a04"]])

export default __exports__